import React, { useState } from "react";
import Alert from "../../../controls/Alert";

const TriplegEventValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (!error && !record.delayCode) {
    error = true;
    errorMessage = "A 'Delay Code' is required";
  }

  if (!error && !record.delayOffsetFrom) {
    error = true;
    errorMessage = "A 'Offset From' is required";
  }

  if (!error && (!record.delayMinutes || isNaN(record.delayMinutes))) {
    error = true;
    errorMessage = "A 'Duration' is required";
  }

  if (!error && record.delayMinutes < 0) {
    error = true;
    errorMessage = "A 'Duration' must be greater thn zero";
  }

  if (!error && record.delayMinutes > 6000) {
    error = true;
    errorMessage = "A 'Duration' value is too large";
  }

  // if (!error && record.delayRequired && record.delayApplied === null) {
  //   error = true;
  //   errorMessage = "A 'Delay Action' is required";
  // }

  if (!error && !record.noteText) {
    error = true;
    errorMessage = "A 'Delay Reason' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default TriplegEventValidator;
